import React from 'react';
import './AboutUsIletisim.css'; // CSS dosyasını import ediyoruz

const AboutUsIletisim = () => {
    return (
        <section className="iletisim-section">
            <h1 class="iletisim-baslik">İletişim</h1>
            <div class="iletisim-alt-baslik-container">
            </div>
            <div class="metin">
                <h3 class="iletisim-metin">
                    Soru, destek ve talepleriniz için bize aşağıdaki <br/>
                     mail adresinden ulaşabilirsiniz. <br/> <span class="iletisim-metin-mail">info@lingify.co</span></h3>
            </div>
        </section>
    );
};

export default AboutUsIletisim;